import React, { useState } from 'react';
import { FiChevronLeft, FiChevronRight, FiCheck } from 'react-icons/fi';

const StepIndicator = ({ steps, current }) => (
  <div style={{ display: 'flex', alignItems: 'flex-start', marginBottom: 30 }}>
    {steps.map((step, i) => {
      const done = i < current;
      const active = i === current;
      return (
        <React.Fragment key={i}>
          <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 6 }}>
            <div style={{
              width: 36, height: 36, borderRadius: '50%', flexShrink: 0,
              background: done ? '#1e3a4c' : active ? '#1e3a4c' : '#f1f5f9',
              color: done || active ? '#fff' : '#94a3b8',
              display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontWeight: 700, fontSize: 14,
              boxShadow: active ? '0 0 0 4px rgba(82,148,181,0.14)' : 'none',
              transition: 'all 0.25s',
            }}>
              {done ? <FiCheck size={15} strokeWidth={3} /> : i + 1}
            </div>
            <span style={{
              fontSize: 11, fontWeight: active ? 600 : 400,
              color: active ? '#1e3a4c' : done ? '#1e3a4c' : '#94a3b8',
              textAlign: 'center', whiteSpace: 'nowrap',
              transition: 'color 0.25s',
            }}>
              {step}
            </span>
          </div>
          {i < steps.length - 1 && (
            <div style={{
              flex: 1, height: 2,
              background: i < current ? '#1e3a4c' : '#e2e8f0',
              margin: '17px 8px 0',
              transition: 'background 0.25s',
            }} />
          )}
        </React.Fragment>
      );
    })}
  </div>
);

const FormWizard = ({
  title, icon, steps, children, onSubmit,
  submitLabel = 'Salvar', fullPage,
}) => {
  const [current, setCurrent] = useState(0);
  const stepItems = Array.isArray(children) ? children : [children];
  const isLast = current === steps.length - 1;

  const outerStyle = fullPage
    ? { display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', padding: '20px', background: '#f8fafc' }
    : { width: '100%', padding: '28px 24px 48px' };

  return (
    <div style={outerStyle}>
      <div style={{
        width: '100%',
        maxWidth: fullPage ? 460 : '100%',
        margin: '0 auto',
        background: '#fff',
        borderRadius: 6,
        border: '1px solid #e5e7eb',
        overflow: 'hidden',
      }}>
        {/* Body */}
        <div style={{ padding: '28px 40px 36px' }}>
          {steps.length > 1 && <StepIndicator steps={steps} current={current} />}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 18 }}>
            {stepItems[current]}
          </div>

          {/* Navigation */}
          <div style={{ display: 'flex', gap: 12, marginTop: 32 }}>
            {current > 0 && (
              <button
                type="button"
                onClick={() => setCurrent(c => c - 1)}
                style={{
                  flex: 1, height: 48, borderRadius: 4,
                  background: '#f8fafc', color: '#475569',
                  border: '1.5px solid #e2e8f0', fontWeight: 600, fontSize: 14, cursor: 'pointer',
                  display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                  transition: 'background 0.15s',
                }}
                onMouseEnter={e => { e.currentTarget.style.background = '#f1f5f9'; }}
                onMouseLeave={e => { e.currentTarget.style.background = '#f8fafc'; }}
              >
                <FiChevronLeft size={18} /> Voltar
              </button>
            )}
            <button
              type="button"
              onClick={() => isLast ? onSubmit?.() : setCurrent(c => c + 1)}
              style={{
                flex: current > 0 ? 2 : 1, height: 48, borderRadius: 4,
                background: '#10b981',
                color: '#fff', border: 'none', fontWeight: 600, fontSize: 14, cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 6,
                transition: 'opacity 0.15s',
              }}
              onMouseEnter={e => { e.currentTarget.style.background = '#059669'; }}
              onMouseLeave={e => { e.currentTarget.style.background = '#10b981'; }}
            >
              {isLast ? submitLabel : (<>Próximo <FiChevronRight size={18} /></>)}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FormWizard;
